import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/dashboards',
        component: () => import('@/pages/dashboards/Dashboards.vue'),
        name: 'dashboards',
        meta: {
            title: 'Dashboards',
            middleware: [GateKeeperMiddleware],
            ability: ({ gateKeeper, to }) =>
                gateKeeper.userHasPermission('view a dashboard') ||
                gateKeeper.userHasPermission('view insight dashboard') ||
                gateKeeper.userHasGroupPermission('view insight dashboard') ||
                gateKeeper.userIsGroupInstructor(),
        },
    },
];
